import lrLayerSelect from './_src/lrLayerSelect.vue'

lrLayerSelect.install = function(Vue) {
  Vue.component(lrLayerSelect.name, lrLayerSelect)
}

export default lrLayerSelect